export default __webpack_public_path__ + "static/media/bluetree.32c5e0d8.png";